import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Input, Select } from "@rocketseat/unform";
import { FaStream, FaDollarSign } from "react-icons/fa";
import PropType from "prop-types";
import api from "../../../../services/api";
import handleError from "../../../../services/apiErrorHandler";

import "../../styles.css";
import { Row, Col, Modal, Button, notification, Switch } from "antd";
import CurrencyField from "../../../../components/CurrencyField";
import OperadoresField from "../../../../components/Acordo/OperadoresField";

import ParcelaForm from "../../../../components/Acordo/ParcelaForm";
import validateData from "../Validation";
import * as Yup from "yup";
import { ContratoFieldsProvider } from "./use-contrato-fields";

class Formulario extends Component {
  /**
   * Informações recebidas por propriedade
   */
  static propTypes = {
    pasta: PropType.object
  };

  state = {
    loading: false,
    qntParcelas: 0, // Quantidade de parcelas selecionada
    valorAcordo: 0, // Valor do acordo definido pelo usuário
    valorOriginal: 0, // Valor original da dívida
    valorEntrada: 0,
    hasValorEntrada: false,
    participaCampanha: false,
    tiposAcordo: [],
    tipoAcordo: null,
    contrato_button: 1,
    tipo_cobranca: 0,
    formaPagamento: "BOLETO_ASAAS"
  };

  /**
   * Retorna uma data no formato:
   * YYYY-MM-DD
   */
  formatDate = date => {
    let dtString = date.toLocaleDateString("pt-BR").split("/");
    let finalDate = `${dtString[2]}-${dtString[1]}-${dtString[0]}`; // 0000-00-00

    return finalDate;
  };

  handleFormaPagamentoChange = event => {
    this.setState({
      formaPagamento: event.target.value
    });
  };

  /** Valida as informações e cadastra o acordo */
  handleSubmit = async data => {
    const validationResult = validateData(data);

    if (!validationResult.success) {
      Modal.error({
        title: "Error",
        content: validationResult.error
      });
      return;
    }

    console.log("Data", data);
    const pasta = this.props.pasta.pasta;
    const data_acordo = this.formatDate(data.data_acordo);
    const operador = data.operador;
    const tipo_acordo = this.state.tipoAcordo;
    const valor_acordo = data.valor_acordo;
    const valor_contrato = data.valor_contrato;
    const qntParcelas = parseInt(data.qnt_parcelas);
    const valor_atualizado = data.valor_atualizado;
    const produto = data.produto;
    const parcela_set = [];
    let contrato_set = [];
    const tipo_cobranca = this.state.tipo_cobranca;
    const notes = document.getElementById("notes").value;
    const numero_processo = data.numero_processo;
    const dias_em_atraso = data.dias_em_atraso;
    const forma_pagamento = this.state.formaPagamento;

    if (
      (tipo_cobranca == "JUDICIAL" && numero_processo === "") ||
      numero_processo === null
    ) {
      window.alert("Numero do processo obrigatorio");
      return;
    }

    for (let i = 1; i <= this.state.contrato_button; i++) {
      contrato_set.push({
        contrato: data[`contrato${i}`],
        carteira_produto: data[`carteira_produto_${i}`],
        valor_do_contrato: data[`valor_contrato_${i}`],
        percentual: data[`percentual_${i}`],
        valor_total: data[`valor_total_${i}`]
      });
    }

    for (let i = 1; i <= qntParcelas; i++) {
      const valor_parc = data[`parcela_${i}`];
      const data_venc = data[`date_${i}`];

      parcela_set.push({
        num_parcela: i,
        valor_parcela: valor_parc,
        data_vencimento: this.formatDate(data_venc),
        forma_pagamento: forma_pagamento
      });
    }

    if (this.state.hasValorEntrada) {
      parcela_set.push({
        num_parcela: 0,
        valor_parcela: this.state.valorEntrada,
        data_vencimento: this.formatDate(new Date()),
        forma_pagamento: forma_pagamento
      });
    }

    const cad_obj = {
      parcela_set,
      data_acordo,
      valor_acordo,
      pasta,
      operador,
      tipo_acordo,
      participa_campanha: this.state.participaCampanha,
      nome_campanha: this.state.participaCampanha ? data.nome_campanha : "",
      numero_cliente: data.numero_cliente,
      valor_contrato,
      valor_atualizado,
      produto,
      contrato_set,
      tipo_cobranca,
      numero_processo,
      notes,
      dias_em_atraso
    };

    console.log(cad_obj);
    this.setState({
      loading: true
    });

    await api
      .post("/acordo/acordos/", cad_obj)
      .then(() => {
        notification.success({
          message: "Acordo cadastrado com sucesso!"
        });
        /** Redirecionar para a visualização do acordo */
        this.props.redirect(`/pasta/${pasta}/acordos`);
      })
      .catch(err => {
        Modal.error({
          title: "Error",
          content: handleError(err)
        });
      });

    this.setState({
      loading: false
    });
  };

  /**
   * Evento quando o tipo de acordo é alterado
   */
  handleTipoAcordoChange = event => {
    const type = event.target.value;
    const acordoTypes = this.getAcordoTypes();
    let tipo_acordo;
    acordoTypes.map(value => {
      if (value.id.toString() === type) {
        tipo_acordo = value.title;
      }
    });

    const hasValorEntrada = ["Parcelado"].includes(tipo_acordo);

    this.setState({
      ...this.state,
      tipoAcordo: tipo_acordo,
      hasValorEntrada,
      valorEntrada: hasValorEntrada ? this.state.valorEntrada : 0
    });
  };

  /** Quantidade de parcelas change */
  handleParcelaChange = event => {
    const qntParc = event.target.value;

    this.setState({
      qntParcelas: parseFloat(qntParc)
    });
  };

  /** Atualiza o valor do acordo */
  handleValorAcordoChange = value => {
    /** O valor do acordo não pode ser maior que o valor original */

    this.setState({
      ...this.state,
      valorAcordo: value
    });
  };

  handleValorEntradaChange = value => {
    this.setState({
      ...this.state,
      valorEntrada: value
    });
  };

  // Atualiza o estado com dados da pasta (valor original)
  async componentDidMount() {
    const valor_original = this.props.pasta.valor_divida;

    this.setState({
      valorOriginal: valor_original
    });

    /** Carrega os tipos de acordo */
    await api
      .get("/tipo_acordo/")
      .then(response => {
        const types = response.data;

        this.setState({
          tiposAcordo: types
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  /**
   * Retorna a lista de tipos de acordo
   */
  getAcordoTypes = () => {
    const types = [
      { id: 0, title: "Selecione" },
      { id: 1, title: "À vista" },
      { id: 2, title: "Parcelado" },
      { id: 3, title: "Levantamento de valor" }
    ];
    return types;
  };

  /**
   * Validações com Yup
   */
  formSchema = () => {
    // Campos de parcela/datas
    const dynamicFields = {};

    if (parseInt(this.state.qntParcelas) != 0) {
      for (let i = 1; i <= parseInt(this.state.qntParcelas); i++) {
        dynamicFields[`parcela_${i}`] = Yup.number();
        dynamicFields[`date_${i}`] = Yup.date().typeError("Data inválida!");
      }
    }
    for (let i = 1; i <= this.state.contrato_button; i++) {
      dynamicFields[`contrato${i}`] = Yup.string();
      dynamicFields[`carteira_produto_${i}`] = Yup.string().required(
        "Campo obrigatório"
      );
      dynamicFields[`valor_contrato_${i}`] = Yup.mixed().notOneOf(
        [NaN, null, 0, 0.0, "0"],
        "Campo obrigatório."
      );
      dynamicFields[`percentual_${i}`] = Yup.number().typeError("");
      dynamicFields[`valor_total_${i}`] = Yup.number().typeError("");
    }
    if (this.state.hasValorEntrada) {
      dynamicFields["valor_entrada"] = Yup.number().typeError("Campo inválido");
    }

    const schema = {
      ...dynamicFields,
      valor_atualizado: Yup.mixed().notOneOf(
        [NaN, null, 0, 0.0, "0"],
        "Campo inválido."
      ),
      valor_contrato: Yup.mixed().notOneOf(
        [NaN, null, 0, 0.0, "0"],
        "Campo inválido."
      ),
      valor_acordo: Yup.mixed().notOneOf(
        [NaN, null, 0, 0.0, "0"],
        "Campo inválido."
      ),
      numero_cliente: Yup.string().required("Campo obrigatório"),
      qnt_parcelas: Yup.mixed().notOneOf(["Selecione"], "Campo inválido."),
      operador: Yup.mixed().notOneOf(["0"], "Campo inválido."),
      sdr: Yup.number(),
      backoffice: Yup.number(),
      dias_em_atraso: Yup.number(),
      data_acordo: Yup.date().typeError("Campo obrigatório!"),
      tipo_cobranca: Yup.string(),
      numero_processo: Yup.string()
    };

    // Dynamic
    if (this.state.participaCampanha) {
      Object.assign(schema, {
        nome_campanha: Yup.string().required("Campo obrigatório")
      });
    }

    return Yup.object().shape(schema);
  };

  increaseButton = () => {
    let value = this.state.contrato_button;
    value = value + 1;
    this.setState({
      ...this.setState,
      contrato_button: value
    });
  };

  decreaseButton = () => {
    let value = this.state.contrato_button;
    value = value - 1;
    this.setState({
      ...this.setState,
      contrato_button: value
    });
  };

  handleTipoCobrancaChange = event => {
    const type = event.target.value;
    this.setState({
      ...this.state,
      tipo_cobranca: type
    });
  };

  numProcessoField = () => {
    if (this.state.tipo_cobranca == "JUDICIAL") {
      return (
        <div className="acordo__field">
          <label>Numero Processo:</label>
          <Input name="numero_processo" className="ant-input" />
        </div>
      );
    }
  };

  componentDidUpdate(_, prevState) {
    if (
      prevState.participaCampanha !== this.state.participaCampanha &&
      this.state.participaCampanha
    ) {
      document.getElementById("nome_campanha").focus();
    }
  }

  render() {
    /** Valores iniciais do formulário */
    console.log(this.state);
    const initialData = {
      qnt_parcelas: "Selecione",
      operador: "Selecione",
      backoffice: "Selecione",
      sdr: "Selecione",
      tipo_acordo: "Selecione",
      tipo_cobranca: "Selecione"
    };

    /** Opções de parcela */
    const INSTALLMENTS_AMOUNT = Array.from({ length: 120 }, (_, i) => i + 1);
    let parcelas = [
      { id: "Selecione", title: "Selecione" },
      ...INSTALLMENTS_AMOUNT.map(number => ({
        id: number,
        title: `${number}x`
      }))
    ];

    return (
      <div className="acordo__container">
        <Form
          onSubmit={this.handleSubmit}
          initialData={initialData}
          schema={this.formSchema()}
        >
          <div className="acordo__fields">
            <div className="acordo__block_title">
              <FaStream />
              &nbsp;&nbsp;Detalhes do acordo
            </div>
            <div style={{ padding: "10px" }}>
              <Row gutter={8}>
                {/** Valor do acordo */}
                <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Valor do acordo</label>
                    <CurrencyField
                      name="valor_acordo"
                      className="ant-input"
                      placeholder="R$"
                      onChangeEvent={this.handleValorAcordoChange}
                    />
                  </div>
                </Col>

                {/** Valor atualizado */}
                <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Valor atualizado</label>
                    <CurrencyField
                      name="valor_atualizado"
                      className="ant-input"
                      placeholder="R$"
                    />
                  </div>
                </Col>

                {/** Valor principal */}
                <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Valor principal</label>
                    <CurrencyField
                      name="valor_contrato"
                      className="ant-input"
                      placeholder="R$"
                      value={this.state.valorOriginal}
                    />
                  </div>
                </Col>

                {/** Tipo do acordo */}
                <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Tipo do acordo</label>
                    <Select
                      name="tipo_acordo"
                      className="ant-input"
                      autoFocus={true}
                      onChange={this.handleTipoAcordoChange}
                      options={this.getAcordoTypes()}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={8}>
                {/** Parcelas */}
                <Col md={{ span: 4 }}>
                  <div className="acordo__field">
                    <label>Qnt. de parcelas:</label>
                    {/* prettier-ignore */}
                    <Select
                      name="qnt_parcelas"
                      className="ant-input"
                      options={parcelas}
                      onChange={this.handleParcelaChange}

                    />
                    {/* prettier-ignore-end */}
                  </div>
                </Col>

                {/** Data do acordo */}
                <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Data do acordo:</label>
                    <Input
                      type="date"
                      name="data_acordo"
                      className="ant-input"
                    />
                  </div>
                </Col>
                <Col md={{ span: 7 }}>
                  <div className="acordo__field">
                    <label>Operador:</label>
                    <OperadoresField name="operador" className="ant-input" />
                  </div>
                </Col>
                {/** Valor de entrada */}
                {this.state.hasValorEntrada && (
                  <Col md={{ span: 5 }}>
                    <div className="acordo__field">
                      <label>Valor entrada:</label>
                      {/* prettier-ignore */}
                      <CurrencyField
                        name="valor_entrada"
                        className="ant-input"
                        placeholder="R$"
                        value={this.state.valorEntrada}
                        onChangeEvent={this.handleValorEntradaChange}
                      />
                      {/* prettier-ignore-end */}
                    </div>
                  </Col>
                )}
                {/* <Col md={{ span: 6 }}>
                  <div className="acordo__field">
                    <label>Produto/Carteira:</label>
                    <Input type="text" name="produto" className="ant-input" />
                  </div>
                </Col> */}
              </Row>
              <Row gutter={8}>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Dias em atraso:</label>
                    <Input
                      type="number"
                      name="dias_em_atraso"
                      className="ant-input"
                    />
                  </div>
                </Col>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Tipo de Cobranca:</label>
                    {/* prettier-ignore */}
                    <Select
                      name="tipo_cobranca"
                      className="ant-input"
                      options={[
                        { id: 0, title: "Selecione" },
                        { id: "JUDICIAL", title: "JUDICIAL" },
                        { id: "EXTRAJUDICIAL", title: "EXTRAJUDICIAL" }
                      ]}
                      onChange={this.handleTipoCobrancaChange}

                    />
                    {/* prettier-ignore-end */}
                  </div>
                </Col>
                <Col md={{ span: 8 }}>{this.numProcessoField()}</Col>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Forma de Pagamento:</label>
                    <Select
                      name="forma_pagamento"
                      className="ant-input"
                      options={[
                        { id: "DEBITO_CONTA", title: "Débito em Conta" },
                        { id: "BOLETO_ASAAS", title: "Boleto Asaas" },
                        { id: "PIX", title: "PIX" },
                        { id: "DINHEIRO", title: "Dinheiro" },
                        { id: "CARTAO", title: "Cartão" },
                        { id: "OUTROS", title: "Outros" }
                      ]}
                      value={this.state.formaPagamento}
                      onChange={this.handleFormaPagamentoChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Número cliente:</label>
                    <Input
                      type="text"
                      name="numero_cliente"
                      className="ant-input"
                    />
                  </div>
                </Col>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Participa campanha?</label>
                    <div style={{ padding: "8px 0" }}>
                      <Switch
                        name="participa_campanha"
                        onChange={() =>
                          this.setState({
                            participaCampanha: !this.state.participaCampanha
                          })
                        }
                        checked={this.state.participaCampanha}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={{ span: 8 }}>
                  <div className="acordo__field">
                    <label>Nome campanha:</label>
                    <Input
                      id="nome_campanha"
                      type="text"
                      name="nome_campanha"
                      placeholder={
                        this.state.participaCampanha
                          ? "Insira o nome da campanha"
                          : ""
                      }
                      className="ant-input"
                      disabled={!this.state.participaCampanha}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={8}>
                <div className="acordo__field">
                  <label>OBS:</label>
                  <textarea id="notes" className="ant-input" />
                </div>
              </Row>
              <Row gutter={24}>
                <ContratoFieldsProvider
                  valorAcordo={this.state.valorAcordo}
                  onFieldAdd={this.increaseButton}
                  onFieldRemove={this.decreaseButton}
                />
              </Row>
            </div>
          </div>
          <div className="acordo__parcelas">
            <div className="acordo__block_title">
              <FaDollarSign />
              &nbsp;&nbsp;Valor das parcelas
            </div>
            <div style={{ padding: "10px" }}>
              {/** Tabela de parcelas */}
              <ParcelaForm
                valorAcordo={parseFloat(this.state.valorAcordo)}
                qntParcelas={this.state.qntParcelas}
                valorEntrada={this.state.valorEntrada}
                hasValorEntrada={this.state.hasValorEntrada}
                acordo="amigavel"
              />
            </div>
          </div>
          <div style={{ textAlign: "end", margin: "10px" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={this.state.loading}
            >
              Salvar
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect(state => state.redirect)(Formulario);



// WEBPACK FOOTER //
// ./src/pages/Acordo/Create/Formulario/index.js